export default __webpack_public_path__ + "static/media/portfolio.a2069031.png";